import * as ambassadorWixPromoteSeoV1HeadlessSitemapEntry from './promote-seo-v1-headless-sitemap-entry-seo-sitemap-entries.http.js';
import * as ambassadorWixPromoteSeoV1HeadlessSitemapEntryTypes from './promote-seo-v1-headless-sitemap-entry-seo-sitemap-entries.types.js';
import * as ambassadorWixPromoteSeoV1HeadlessSitemapEntryUniversalTypes from './promote-seo-v1-headless-sitemap-entry-seo-sitemap-entries.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function listSitemapPages(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixPromoteSeoV1HeadlessSitemapEntryUniversalTypes.ListSitemapPagesRequest,
  ambassadorWixPromoteSeoV1HeadlessSitemapEntryTypes.ListSitemapPagesRequest,
  ambassadorWixPromoteSeoV1HeadlessSitemapEntryUniversalTypes.ListSitemapPagesResponse,
  ambassadorWixPromoteSeoV1HeadlessSitemapEntryTypes.ListSitemapPagesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPromoteSeoV1HeadlessSitemapEntry.listSitemapPages(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/list-sitemap-pages',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  SitemapEntry as SitemapEntryOriginal,
  Image as ImageOriginal,
  Video as VideoOriginal,
  ListSitemapPagesRequest as ListSitemapPagesRequestOriginal,
  ItemType as ItemTypeOriginal,
  ItemTypeWithLiterals as ItemTypeWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  ListSitemapPagesResponse as ListSitemapPagesResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  ListStaticSitemapPagesRequest as ListStaticSitemapPagesRequestOriginal,
  ListStaticSitemapPagesResponse as ListStaticSitemapPagesResponseOriginal,
} from './promote-seo-v1-headless-sitemap-entry-seo-sitemap-entries.types.js';
